import React from 'react'
import Layout from './layout'
import heroDesktopBanner from "../assets/images/developer-banner.jpg"
import heroMobileBanner from "../assets/images/developer-bannermobile.jpg"
import startToFinishBanner from "../assets/images/realestatebanner.jpg"
import startToFinishBannerMobile from "../assets/images/realestatebannermobile.jpg"
import halfOverlayBanner from "../assets/images/half-overlay-banner.jpg"
import afterBeforeBg from "../assets/images/Rolex-87-2.jpg"
import authorImg from "../assets/images/authorImg.jpg"
import { Link } from 'react-router-dom'
import OurClientSlider from '../components/OurClientSlider'
import HomeTestimonial from '../components/HomeTestimonial';
import OurPortfolio from '../components/OurPortfolio'
import OurProcess from '../components/OurProcess'

const ForDevelopers = () => {
  return (
    <Layout>
            <div className='interior-designer image-banner hero-banner full-screen position-relative color-light d-flex align-end d-ps-100'>
                <picture className="cover bottom-overlay position-absolute top-0 start-0">
                    <source media="(max-width:768px)" srcSet={heroMobileBanner} />
                    <img className="cover" src={heroDesktopBanner} alt="" />
                </picture>
                <div className='container'>
                    <div className='banner-content grid-blocks d-grid large-small gap-40 d-gap-100'>
                        <div className='grid-block'>
                            <div className='summary-block'>
                                <h6 className='mb-20 font-medium text-uppercase'>IVEY FOR DEVELOPERS</h6>
                                <h1 className='font-thin mb-20'>a choice partner for complete design-build services in Miami</h1>
                                <p>We specialize in bringing interior designs for commercial and hospitality with precision and attention to detail at scale for a consistent, lasting turnkey result.</p>
                            </div>
                        </div>
                        <div className='grid-block d-flex flex-column justify-end pb-20'>
                            <div className='buttons-block d-flex flex-column gap-20 align-start justify-end'>
                                <Link to='/projects' className='button bottom-border light-border pb-5 pe-10'>View our portfolio</Link>
                                <Link to='/contact' className='button bottom-border light-border pb-5 pe-10'>Contact our team</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='counter-block bg-black py-60 d-py-100'>
                <div className='container' data-aos="fade-up" data-aos-delay="100" data-aos-duration="600">
                    <div className='about-detail-right-sec d-ps-100'>
                        <div className='featured-list d-flex'>
                            <div className='featured-list-item d-flex flex-column'>
                                <span className='font-38 text-white'>150+</span>
                                <span className='featured-text font-11 text-white text-uppercase'>BUILD PROJECTS</span>
                            </div>
                            <div className='featured-list-item d-flex flex-column'>
                                <span className='font-38 text-white'>100+</span>
                                <span className='featured-text font-11 text-white text-uppercase'>DESIGN PROJECTS</span>
                            </div>
                            <div className='featured-list-item d-flex flex-column'>
                                <span className='font-38 text-white'>13+</span>
                                <span className='featured-text font-11 text-white text-uppercase'>years experience</span>
                            </div>
                            <div className='featured-list-item d-flex flex-column'>
                                <span className='font-38 text-white'>15+</span>
                                <span className='featured-text font-11 text-white text-uppercase'>CITIES SERVICED</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <OurClientSlider />
            <div className='for-developer real-estate start-to-finish image-banner hero-banner large-screen position-relative color-light d-flex align-center pb-60'>
                <picture className="cover bottom-overlay position-absolute left-overlay top-0 start-0">
                    <source media="(max-width:768px)" srcSet={afterBeforeBg} />
                    <img className="cover" src={afterBeforeBg} alt="" />
                </picture>
                <div className='container'>
                    <div className='banner-content grid-blocks d-grid' data-aos="fade-up" data-aos-delay="100" data-aos-duration="600">
                        <div className='grid-block'>
                            <div className='summary-block'>
                                <h6 className='mb-20 font-medium'>A DESIGN BUILD PARTNER</h6>
                                <h2 className='font-thin mb-30'>Ivey Design Build achieves flawless execution at scale</h2>
                                <div className='text-block'>Our team offers comprehensive, end-to-end services tailored to support property developers throughout every phase of a project. From initial concept and site analysis to architectural design, engineering, permitting, and construction, we streamline the entire process. This integrated approach ensures seamless communication, faster project delivery, and tighter cost control, allowing developers to minimize risk and maximize return on investment. Our team collaborates closely with clients to align design vision with project goals, providing practical, buildable solutions that meet market demands and regulatory requirements.</div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <OurProcess />
            <div className="half-overlay-banner color-light position-relative">
                <picture className="w-100 bottom-overlay position-absolute w-100 h-100">
                    <source media="(max-width:768px)" srcSet={halfOverlayBanner} />
                    <img className="cover" src={halfOverlayBanner} alt="" />
                </picture>
                <div className='contant-box d-flex position-absolute w-100 h-100 top-0 start-0'>
                    <div className="left-block d-flex flex-column justify-center">
                        <div className="summary mb-30 d-mb-50" data-aos="fade-up" data-aos-delay="100" data-aos-duration="600">
                            <h2>“They are extremely hard working, don't take short cuts, do the job properly the first time, follow through until the job is completely finished and get it done promptly.”</h2>
                        </div>
                        <div className='author-block d-flex no-wrap align-center gap-20' data-aos="fade-up" data-aos-delay="150" data-aos-duration="600">
                            {/* <img className='cover' src={authorImg} alt='' /> */}
                            <div className='author-detail'>
                                <h3>Recent client</h3>
                                <div className='h6 font-medium uppercase'>MIAMI REALTOR</div>
                            </div>
                        </div>
                    </div>
                    <div className="right-block h-100 d-flex align-end py-60 d-px-120 py-60">
                        <Link to='/single-project/turnberry' className='button bottom-border light-border pb-5 pe-10'>VIEW PROJECT </Link>
                    </div>
                </div>

            </div>

            <HomeTestimonial />
            <OurPortfolio />
        </Layout>
  )
}

export default ForDevelopers